import CircularProgress from '@material-ui/core/CircularProgress';
import { green, orange, red } from '@material-ui/core/colors';
import Clock from '@material-ui/icons/AccessTime';
import NotStartedIcon from '@material-ui/icons/AdjustOutlined';
import CheckBoxRounded from '@material-ui/icons/CheckCircle';
import Close from '@material-ui/icons/Close';
import Error from '@material-ui/icons/Error';
import Warning from '@material-ui/icons/Warning';
import React from 'react';
import { ExecutionStatus } from './ExecutionConstants';

interface Props {
  type: ExecutionStatus;
}

const IconTypeMap = {
  Passed: <CheckBoxRounded style={{ color: green[500] }} />,
  Failed: <Error style={{ color: red[500] }} />,
  InProgress: <CircularProgress size={20} />,
  Scheduled: <Clock />,
  Ready: <NotStartedIcon />,
  Cancelled: <Close />,
  AwaitingApprovals: <NotStartedIcon />,
  PassedWithWarnings: <Warning style={{ color: orange[500] }} />
};

function ExecutionStatusIcon(props: Props) {
  const { type } = props;
  return IconTypeMap[type];
};

export default ExecutionStatusIcon;
